import React from 'react';
import Box from '@sendsprint/ui-react/dist/components/Box';
import Text from '@sendsprint/ui-react/dist/components/Text';
import Image from '@src/components/image';
import whiteLabelIllustrationImg from '@src/layouts/auth/assets/white-label-illustration.png';

const AsideContentWhiteLabel = () => {
  return (
    <Box>
      <Image
        className="ss-w-full ss-mx-auto ss-h-[350px] ss-overflow-hidden ss-mb-5"
        imgClasses="ss-h-full object-contain"
        alt=""
        src={whiteLabelIllustrationImg}
        variant="eager-load"
      />
      <Box className="ss-px-10">
        <Text variant="h4" className="ss-text-white">
          Remittance and Regulatory Infrastructure Simplified
        </Text>
        <Text variant="paragraphLarge" className="ss-text-white">
          Powerful and fully-compliant remittance infrastructure and licenses, tailored to your
          needs
        </Text>
      </Box>
    </Box>
  );
};

export default AsideContentWhiteLabel;
